import React, { useState, useRef, useEffect } from "react";

function Topbar({ toggleSidebar, user, onLogout }) {
  const [dropOpen, setDropOpen] = useState(false);
  const dropRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const initials = user
    ? user.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)
    : "A";

  return (
    <div
      className="topbar d-flex align-items-center justify-content-between px-4"
      style={{ height: 60, background: "white", borderBottom: "1px solid #eee", position: "sticky", top: 0, zIndex: 99 }}
    >
      {/* Left: Toggle + Breadcrumb */}
      <div className="d-flex align-items-center gap-3">
        <button
          onClick={toggleSidebar}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 20,
            color: "#5d4037",
            padding: 4,
            borderRadius: 6,
            lineHeight: 1,
          }}
          title="Toggle Sidebar"
        >
          <i className="bi bi-list"></i>
        </button>
        <div style={{ height: 20, width: 1, background: "#eee" }}></div>
        <span style={{ fontSize: 13, color: "#aaa", fontWeight: 400 }}>
          Interior ERP
        </span>
      </div>

      {/* Right: User Avatar + Dropdown */}
      <div ref={dropRef} style={{ position: "relative" }}>
        <button
          onClick={() => setDropOpen(o => !o)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: dropOpen ? "#fdf6ec" : "none",
            border: "1px solid",
            borderColor: dropOpen ? "#b8860b44" : "transparent",
            borderRadius: 10,
            padding: "5px 10px 5px 5px",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          {/* Avatar */}
          <div style={{
            width: 34,
            height: 34,
            borderRadius: 10,
            background: "linear-gradient(135deg, #3e2723, #5d4037)",
            color: "#f5c842",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: 13,
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: 0.5,
            flexShrink: 0,
          }}>
            {initials}
          </div>
          {/* Name */}
          <div style={{ textAlign: "left" }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#3e2723", lineHeight: 1.2 }}>
              {user?.name || "Admin"}
            </div>
            <div style={{ fontSize: 11, color: "#aaa", lineHeight: 1.2 }}>
              {user?.role || "Administrator"}
            </div>
          </div>
          {/* Caret */}
          <i
            className={`bi bi-chevron-${dropOpen ? "up" : "down"}`}
            style={{ fontSize: 11, color: "#aaa", marginLeft: 2, transition: "transform 0.2s" }}
          ></i>
        </button>

        {/* Dropdown Menu */}
        {dropOpen && (
          <div style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            background: "white",
            borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)",
            minWidth: 190,
            overflow: "hidden",
            animation: "dropFadeIn 0.2s ease",
            zIndex: 200,
          }}>
            <style>{`
              @keyframes dropFadeIn {
                from { opacity: 0; transform: translateY(-8px); }
                to { opacity: 1; transform: translateY(0); }
              }
            `}</style>

            {/* User Info Header */}
            <div style={{ padding: "14px 16px 10px", borderBottom: "1px solid #f0f0f0" }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#3e2723" }}>{user?.name}</div>
              <div style={{ fontSize: 11, color: "#aaa" }}>ID: {user?.id}</div>
            </div>

            {/* Menu Items */}
            <div style={{ padding: "6px 0" }}>
              {[
                { icon: "bi-person-circle", label: "My Profile", action: null },
                { icon: "bi-gear", label: "Settings", action: null },
              ].map((item, i) => (
                <button
                  key={i}
                  style={{
                    width: "100%",
                    background: "none",
                    border: "none",
                    cursor: item.action ? "pointer" : "default",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "9px 16px",
                    fontSize: 13,
                    color: item.action ? "#3e2723" : "#bbb",
                    textAlign: "left",
                    transition: "background 0.15s",
                  }}
                  onClick={item.action}
                  onMouseEnter={e => { if (item.action) e.currentTarget.style.background = "#fdf6ec"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "none"; }}
                >
                  <i className={`bi ${item.icon}`} style={{ fontSize: 15 }}></i>
                  {item.label}
                </button>
              ))}
            </div>

            {/* Logout */}
            <div style={{ borderTop: "1px solid #f0f0f0", padding: "6px 0 4px" }}>
              <button
                style={{
                  width: "100%",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 16px",
                  fontSize: 13,
                  color: "#c62828",
                  fontWeight: 600,
                  textAlign: "left",
                  transition: "background 0.15s",
                  borderRadius: "0 0 8px 8px",
                }}
                onClick={() => {
                  setDropOpen(false);
                  onLogout();
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#ffebee"}
                onMouseLeave={e => e.currentTarget.style.background = "none"}
              >
                <i className="bi bi-box-arrow-right" style={{ fontSize: 15 }}></i>
                Sign Out
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Topbar;
